import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=b243536c&scoped=true&"
import script from "./textarea.vue?vue&type=script&lang=js&"
export * from "./textarea.vue?vue&type=script&lang=js&"
import style0 from "./textarea.vue?vue&type=style&index=0&id=b243536c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b243536c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b243536c')) {
      api.createRecord('b243536c', component.options)
    } else {
      api.reload('b243536c', component.options)
    }
    module.hot.accept("./textarea.vue?vue&type=template&id=b243536c&scoped=true&", function () {
      api.rerender('b243536c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/textarea.vue"
export default component.exports